const STORAGE_KEY = "lg-color-theme";
const DARK_THEME_COLOR = "#0b0d12";
const LIGHT_THEME_COLOR = "#f7f8fb";

function getStoredTheme() {
    try {
        const theme = window.localStorage.getItem(STORAGE_KEY);
        return theme === "light" || theme === "dark" ? theme : null;
    } catch {
        return null;
    }
}

function updateTheme(theme, toggle) {
    document.documentElement.dataset.theme = theme;
    document.querySelector("[data-theme-color]")?.setAttribute("content", theme === "dark" ? DARK_THEME_COLOR : LIGHT_THEME_COLOR);

    if (toggle) {
        const isDark = theme === "dark";
        toggle.setAttribute("aria-label", isDark ? "Ativar tema claro" : "Ativar tema escuro");
        toggle.setAttribute("aria-pressed", String(isDark));
    }
}

export default function initTheme() {
    const toggle = document.querySelector("[data-theme-toggle]");
    const systemTheme = window.matchMedia("(prefers-color-scheme: dark)");

    if (!toggle) {
        return;
    }

    updateTheme(document.documentElement.dataset.theme || (systemTheme.matches ? "dark" : "light"), toggle);

    toggle.addEventListener("click", () => {
        const theme = document.documentElement.dataset.theme === "dark" ? "light" : "dark";
        updateTheme(theme, toggle);

        try {
            window.localStorage.setItem(STORAGE_KEY, theme);
        } catch {
            // The selected theme still applies for the current page.
        }
    });

    systemTheme.addEventListener("change", (event) => {
        if (!getStoredTheme()) {
            updateTheme(event.matches ? "dark" : "light", toggle);
        }
    });
}
